import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('communities', 'reqJoinCommunity');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'join_requests',
  type: 'post',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/communities/reqJoinCommunity.js